import React, {useCallback, useEffect, useState} from "react";
import {GraphQlSelect} from "./GraphQlSelect";
import { useClientQueryQuery} from "../../generated/graphql";
import {GraphQlSelectId} from "./GraphQlSelectId";
import { isObject } from '../id-diff-merge';

export function ClientCompanyAndContactSelect(props) {

    const [searchTerm,setSearchTerm] = useState('');
    const query = useClientQueryQuery({variables:{name:searchTerm?'%'+searchTerm+'%':''}});
    //const query = useClientQueryQuery();
    const changeSearchTerm = useCallback((value)=> {
        setSearchTerm(value);
    },[setSearchTerm]);
    const [currentValue,setCurrentValue] = useState(props.contactValue?{
        id:props?.companyValue?.id+'-'+props?.contactValue?.id,
        contact:props?.contactValue,
        company:props?.companyValue
    }:null);
    useEffect(()=>{
        setCurrentValue(
            props.contactValue?{
                id:props?.companyValue?.id+'-'+props?.contactValue?.id,
                contact:props?.contactValue,
                company:props?.companyValue
            }:null
        );
        setSearchTerm('');
        console.log('CCACS USEFFECT',props.contactValue);
    },[props.companyValue,props.contactValue]);
    const changeValue = ((evt)=>{
        console.log('CCACS change',evt);
        const value = evt.target.value;
        if(!value.id) {
            // just changing the search term, shouldn't really be calling us!
            return;
        }
        props.onChangeCompany({target:{name:props.companyName,value:value?.clientCompany}});
        props.onChangeClient({target:{name:props.contactName,value:value}});
    });
    const renderOptionString = (item)=>{
        console.log('CCACS RENDER',item);
        if(!isObject(item)) return item;
        if(!item?.id) return item.label??'';
        if(item.company) return item?.contact?.name+' / '+(item?.company?.sales_company??item?.company?.accounts_company??'N/A');
        return item?.name+' / '+(item?.clientCompany?.sales_company??'N/A');
    }
    console.log('CCACS',props.contactValue,currentValue,searchTerm);
    return props.valueIsId?
        <GraphQlSelectId {...props} value={currentValue} renderOptionString={renderOptionString} onChange={changeValue} queryResult={query} setSearchTerm={changeSearchTerm} labelField="label"/>
        : <GraphQlSelect {...props} value={currentValue} renderOptionString={renderOptionString} onChange={changeValue} queryResult={query} setSearchTerm={changeSearchTerm} labelField="label"/>;
//    return <GenericLookup retainItemProps={true} hasLookup={true} query={clientQuery} filterOptions={filterOptions} {...props}  value={value} labelField="name" />;
}